import styled, { keyframes } from 'styled-components/macro';
import images from '~/constants/images';
import { Icon as IconComponent } from '~/components';

const appear = keyframes`
  0%{
    opacity: 0;
    transform: translateY(20px);
  }
  100%{
    opacity: 1;
    transform: translateY(0px);
  }
`;

const appear2 = keyframes`
  0%{
    opacity: 0;
  }
  100%{
    opacity: 1;
  }
`;

export const EmptyPageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
  background-color: ${({ theme }) => theme.white};
  padding: 20px;
  text-align: center;
  overflow: hidden;
`;

export const Background = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-image: url(${images.beat});
  background-repeat: no-repeat;
  background-position: calc(50% - 38px) 50%;
  opacity: 0.03;
  background-size: ${({ fit }) => (fit ? 'cover' : '140%')};
  z-index: 0;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    background-size: 302%;
  }
`;

export const Icon = styled(IconComponent)`
  margin-bottom: 30px;
  animation: ${appear2} 0.5s;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  z-index: 1;
`;

export const Subtitle = styled.span`
  font-size: ${({ fit }) => (fit ? 12 : 18)}px;
  font-family: ${({ theme }) => theme.primaryFont};
  animation: ${appear} 0.5s;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    font-size: 14px;
  }
`;

export const Title = styled.span`
  font-size: ${({ fit }) => (fit ? 20 : 40)}px;
  margin-bottom: 10px;
  font-family: ${({ theme }) => theme.primaryFont};
  animation: ${appear} 0.5s;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    font-size: 24px;
  }
`;
